
const Cross = (): React.JSX.Element => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 14 14">
        <path stroke="#010130" strokeWidth="2" d="m.707.707 6 6m6 6-6-6m0 0-6 6 12-12" />
    </svg>
}

export default Cross;


